// extracted by mini-css-extract-plugin
export default {"bodyContainer":"verify_bodyContainer__rrJg8","boldHeading":"verify_boldHeading__RrM4W","errorLink":"verify_errorLink__WiB-b","errorMessage":"verify_errorMessage__VoWBu"};